import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="w-full lg:max-w-5xl lg:mx-auto">
        <h1 className="text-4xl lg:text-6xl mb-6">
          <span className="inline font-extralight leading-normal">From idea to impact, I drive </span>
          <span className="inline leading-normal">0→1 </span>
          <span className="inline font-extralight leading-normal">breakthroughs, accelarate </span>
          <span className="inline leading-normal">GTM </span>
          <span className="inline font-extralight leading-normal">and </span>
          <span className="inline leading-normal">build empowered Product Teams </span>
          <span className="inline font-extralight leading-normal">that scale.</span>
          
        </h1>
      </div>
    </section>
  );
};

export default AboutSection; 